module.exports = __webpack_public_path__ + "img/favicon.3babd546.svg";